export enum ArrowDirectionEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    UP = 'UP',
    DOWN = 'DOWN',
}

export enum LayoutTypeEnum {
    HORIZONTAL = 'HORIZONTAL',
    HORIZONTAL_HIDDEN = 'HORIZONTAL_HIDDEN',
    VERTICAL_LIST = 'VERTICAL_LIST',
    VERTICAL_LIST_HIDDEN = 'VERTICAL_LIST_HIDDEN',
    VERTICAL_FULL = 'VERTICAL_FULL',
    VERTICAL_HIDDEN = 'VERTICAL_HIDDEN',
}
